import "./MicroNirOnsiteW.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Applications from "./sections/Applications";
import Solutions from "./sections/Solutions";
import RelatedServices from "./sections/RelatedServices";
import DiscussCta from "./sections/DiscussCta";
import Footer from "@/reusable_sections/Footer";
export default function MicroNirOnsiteWPage() {
  return <div>
      <Header />
      <Hero />
      <Applications />
      <Solutions />
      <RelatedServices />
      <DiscussCta />
      <Footer />
    </div>;
}